import { SpriteConstant } from 'src/app/constant/sprite.constant';
import { Component, OnChanges, OnInit } from '@angular/core';
import { FavoriteInfoLayoutComponent } from '../core/favoriteinfo.layout.component';
import { FeatureConstant } from '../../../constant/feature.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    selector: 'app-favoriteinfolayoutmobile',
    templateUrl: './favoriteinfo.layout.mobile.component.html',
    styleUrls: ['../css/favoriteinfo.layout.mobile.component.scss'],
    standalone: false
})
export class FavoriteInfoLayoutMobileComponent
  extends FavoriteInfoLayoutComponent
  implements OnInit, OnChanges
{
  //lang_icons: any;
  mobile_icons: any;
  constructor(
    public firebaseAnalyticsServices: FirebaseAnalyticsService,
    public _utilService: UtilService
  ) {
    super(firebaseAnalyticsServices, _utilService);
    this.deviceImage = {
      '1_desktop': 'favorites_fcb_icon_mobile@2x',
      '5_desktop': '5h_desktop_landscape_brown@2x',
      '7_desktop': '7h_mobile_portrait_brown@2x',
      '7_device_landscape': '7h_mobile_portrait_brown@2x',
      '5_device_landscape': '5h_mobile_landscape_brown@2x',
      '3_device_landscape': '3h_mobile_landscape_brown@2x',
      '2_device_portrait': '2h_mobile_portrait_brown@2x',
      '3_device_portrait': '3h_mobile_landscape_brown@2x',
      '7_device_portrait': '7h_mobile_portrait_brown@2x',
      '5_device_portrait': '5h_mobile_landscape_brown@2x',
    };
    this.mobile_icons = SpriteConstant.MOBILE_ICONS;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges() {
    super.ngOnChanges();
    //this.lang_icons = SpriteConstant.LANG_ICONS(this.currentLanguage);
  }

  computeFavoriteList() {
    // console.log('KKKKKKKKKKKKKKKKKKKKKKKK');
    const loc_Favorites = [];
    this.favoritesList = [];
    const len = this.data.length;
    for (let i = 0; i < len; i++) {
      // console.log('this.data.favoriteList[i]');
      // console.log(this.data[i]);
      const obj: any = Object.assign({}, this.data[i]);
      obj.gameType = FeatureConstant[(obj.tableType + '_lang').toUpperCase()];
      obj.tableNum = obj.tableNum;
      obj.select = 0;
      if (obj.device === undefined) {
        if (
          parseInt(obj.seatavailable, 10) === 5 ||
          parseInt(obj.seatavailable, 10) === 3
        ) {
          obj.device = 'device_landscape';
        } else if (parseInt(obj.seatavailable, 10) === 2) {
          obj.device = 'device_portrait';
        }
      }
      loc_Favorites.push(obj);
    }
    this.favoritesList = [...loc_Favorites];
    //console.log('this.favoritesList');
    // console.log(this.favoritesList);
  }

  onIconClick = (action, index = -1) => {
    //console.log('onIconClick',action,index);

    const obj: any = {};
    obj.action = action;
    switch (action) {
      case 'play':
        if (FirebaseConstant.LOBBYMOBILEHEADER['favoritesplay']) {
          this.firebaseAnalyticsServices.triggerFirebase(
            FirebaseConstant.LOBBYMOBILEHEADER,
            'favoritesplay'
          );
        }
        obj.item = this.favoritesList[index];
        // console.log('onIconClick',action,index,'obj',obj);
        this.eventEmit.emit(obj);
        break;
      case 'delete':
        this.selectedIndex = index;
        this.showDeletePopup();
        break;
      case 'close':
        obj.action = action;
        this.eventEmit.emit(obj);
        break;
    }
  };

  showDeletePopup() {
    this.isDeletePopup = true;
  }

  onDeleteYes = (event) => {
    const obj: any = {};
    obj.action = 'delete';
    obj.item = this.data[this.selectedIndex];
    this.eventEmit.emit(obj);
    this.selectedIndex = -1;
    this.isDeletePopup = false;
  };
  onDeleteNo = (event = null) => {
    this.selectedIndex = -1;
    this.isDeletePopup = false;
  };
}
